<template>
  <div>
    <el-form
      :model="reportsForm"
      class="employee-form form"
      :rules="rules"
      ref="reportsForm"
      label-position="left"
      label-width="180px"
    >
      <h3 class="bold mb-40">{{ titleText }} Report</h3>

      <p class="bold">Date Filter</p>

      <div class="mt-20 mb-20">
        <el-form-item label="Select Date" prop="dateRange" class="ml-0">
          <el-date-picker
            v-model="reportsForm.dateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="To"
            start-placeholder="From"
            end-placeholder="To"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>
      </div>

      <div class="flex mt-10 mb-20">
        <el-form-item label-width="0" prop="exclude_weekend">
          <el-checkbox
            label="Exclude Weekends"
            v-model="reportsForm.exclude_weekend"
          ></el-checkbox>
        </el-form-item>
        <el-form-item
          label-width="0"
          class="ml-10"
          prop="exclude_public_holiday"
        >
          <el-checkbox
            label="Exclude Public Holidays"
            v-model="reportsForm.exclude_public_holiday"
          ></el-checkbox>
        </el-form-item>
      </div>
      <button
        class="btn btn-blue no-border btn-full-radius inline-flex flex-v-end mt-40"
        @click.prevent="generateReport()"
      >
        <span>Generate Report</span>
      </button>
    </el-form>
  </div>
</template>

<script>
export default {
  props: {
    titleText: {
      type: String,
      default: "",
    },
    report_type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      reportTypes: this.$store.state.admin.attendance.reports.reportTypes,
      employeeOnlyGroups: this.$store.state.admin.attendance.reports
        .employeeOnlyGroups,
      showGroupBy: true,
      reportsForm: {
        type: this.report_type,
        fetch_by: "employee",
        fetch_by_id: null,
        dateRange: [],
        group_by: "employee",
        exclude_weekend: false,
        exclude_public_holiday: false,
      },
      rules: {
        dateRange: [{ required: true, message: "Please pick a date range" }],
      },
    };
  },
  methods: {
    generateReport() {
      this.$refs[`reportsForm`].validate(valid => {
        if (!valid) {
          return;
        }
        const reportsForm = this.reportsForm;

        if (reportsForm.dateRange <= 0) {
          this.$notification.error("Kindly select date range");
          return false;
        }

        const reportParams = {
          type: reportsForm.type,
          date_from: reportsForm.dateRange[0],
          date_to: reportsForm.dateRange[1],
          exclude_weekend: reportsForm.exclude_weekend,
          exclude_public_holiday: reportsForm.exclude_public_holiday,
        };
        this.$emit("generateReport", reportParams);
      });
    },
  },
};
</script>

<style></style>
